import React from 'react'
import ProfileCheck from '../Components/ProfileCheck'
import Layout from '../Components/Layout/Layout'

const Profile = () => {
  return (
    <>
     <Layout>
        <ProfileCheck />
     </Layout>
    </>
  )
}

export default Profile